export default __webpack_public_path__ + "static/media/edit-icon-disabled.4ae04fea.svg";